export function UserEmailBouncesRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserEmailBounces', {
		url: '/admin/users/email_bounces',
		controllerAs: 'vm',
		controller: UserEmailBouncesCtrl,
		templateUrl: '/ng/hub/User/EmailBounces/UserEmailBouncesCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'Email Bounces',
		},
	});
}

export class UserEmailBouncesCtrl {
	constructor(Api, $filter, $state) {
		'ngInject';
		this.Api = Api;
		this.$state = $state;
		this.dateFormat = $filter('shDate');
		// setup user table
		this.columns = [
			{ field: 'user_id', label: 'User Id', sortable: false },
			{ field: 'fname', label: 'First', sortable: true },
			{ field: 'lname', label: 'Last', sortable: true },
			{ field: 'email', label: 'Email', sortable: true },
			{ field: 'is_active', label: 'Is Active', sortable: true },
			{ field: 'email_bounce_date', label: 'Email Bounce Date', sortable: true },
			{ field: 'email_bounce_reason', label: 'Email Bounce Reason', sortable: false },
			{ field: 'default_hub_name', label: 'Default Hub', sortable: true },
			{ field: 'account', label: 'Account', sortable: true },
			{ field: 'last_login', label: 'Last Login', sortable: true },
		];
		this.limit = 25;
		this.filters = {};
		this.actions = [
			{ label: 'Unbounce', icon: null, callback: this.unbounce.bind(this) },
			{ label: 'Edit', icon: null, callback: this.goToEdit.bind(this) },
		];
	}

	unbounce(user) {
		this.Api.post(`/users/${user.user_id}/unbounce`).then(
			() => {
				this.filters.cb = +new Date();
			},
			() => {}
		);
	}

	goToEdit(user) {
		window.location.href = this.$state.href('hub.loggedin.UserEdit', { id: user.user_id });
	}
}
